const Menu = [
  { path: "/dashboard", icon: "fa fa-sitemap", title: "Dashboard" },
  {
  path: "/team/manageTeam",
    icon: "fa-solid fa-people-group",
    title: "Staff",
  },
  {
    path: "/",
    icon: "fa fa-align-left",
    title: "Product Management",
    children: [
      { path: "/Food-menu/manageFoodMenu", title: "Menus" },
      { path: "/items/manageItems", title: "Menu Items" },
      { path: "/categories/manageCategories", title: "Categories" },
      { path: "/discount/manageDiscount", title: "Discount" },
      { path: "/deal/manageDeals", title: "Combo Deals" },
    ],
  },
  {
    path: "/",
    icon: "fa fa-align-left",
    title: "Customer Management",
    children: [
      { path: "/customer/manageCustomer", title: "Customers" },
    ],
  },
];

export default Menu;

 
  /*
  { path: '/menu', icon: 'fa fa-align-left', title: 'Menu Level',
    children: [
      { path: '/menu/menu-1-1', title: 'Menu 1.1',
        children: [
          { path: '/menu/menu-1-1/menu-2-1', title: 'Menu 2.1',
            children: [
              { path: '/menu/menu-1-1/menu-2-1/menu-3-1', title: 'Menu 3.1' },
              { path: '/menu/menu-1-1/menu-2-1/menu-3-2', title: 'Menu 3.2' }
            ]
          },
          { path: '/menu/menu-1-1/menu-2-2', title: 'Menu 2.2' },
          { path: '/menu/menu-1-1/menu-2-3', title: 'Menu 2.3' },
        ]
      },
      { path: '/menu/menu-1-2', title: 'Menu 1.2' },
      { path: '/menu/menu-1-3', title: 'Menu 1.3' },
    ]
  }
  */
